import { render } from "./DataAnalysis.vue?vue&type=template&id=086b8069&scoped=true"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"

import "./DataAnalysis.vue?vue&type=style&index=0&id=086b8069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086b8069"]])

export default __exports__